import { http } from "../http-common";
import { Pipeline } from "../models/Pipeline";

class PipelineDataService {
    async get(client: string, password: string, portalId: string) {
        return await http(client, password).get<Pipeline[]>(`/hubspot/portal/${portalId}/pipelines`);
    }
}
export default new PipelineDataService();